import { Controller } from "stimulus";

export default class extends Controller {
  static values = { message: String };

  open() {
    if (typeof window.Intercom === "function") {
      window.Intercom("showNewMessage", this.messageValue);
    } else if (window.notyf) {
      window.notyf.error("Messenger isn't available right now. Please email support@busypaws.app.");
    }
  }
}
